<template>
	<KRPlacardLayout class="kr-placard-skeleton">
		<template #header>
			<Skeleton />
		</template>
		<template #mid>
			<div style="width: 50%;">
				<Skeleton />
			</div>
		</template>
		<template #confidence>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #progress>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #current-value>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #target-value>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
	</KRPlacardLayout>
</template>

<script>
import KRPlacardLayout from "./KRPlacardLayout";
import Skeleton from "primevue/skeleton";
export default {
	name: "KRPlacardSkeleton",
	components: {
		KRPlacardLayout,
		Skeleton,
	},
};
</script>

<style lang="scss" scoped>
.skeleton-value {
	width: 50%;
}
</style>
